export default __webpack_public_path__ + "static/media/profileIcon.057c7e28.svg";